import { useEffect, useState } from 'react';

/** Whether a sticky element is pinned at its `top` offset. */
export const useIsStuck = (element: HTMLElement | null) => {
  const [isStuck, setIsStuck] = useState(false);

  useEffect(() => {
    if (!element) {
      return undefined;
    }

    const update = () =>
      setIsStuck(Math.round(element.getBoundingClientRect().top) <= parseFloat(getComputedStyle(element).top));

    update();
    window.addEventListener('scroll', update, { passive: true });

    return () => window.removeEventListener('scroll', update);
  }, [element]);

  return isStuck;
};
